import { faUndo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { UndoRedoHelper } from "../UndoRedoHelper";
import { CanvasDrawer } from "../CanvasDrawer";
import { useStickerSectionStore } from "../EditorStore";
import { CanvasImage } from "../CanvasImage";

export default function UndoRedo() {

    const setCanvasImageSelected = useStickerSectionStore((state) => state.setCanvasImageSelected)
    const selectedCanvasImageRef = useStickerSectionStore((state) => state.currentCanvasImageSelectedRef)
    const setUndoRedo = useStickerSectionStore((state) => state.setUndoRedo)
    const setLayerStatusInStore = useStickerSectionStore((state) => state.setLayerStatus);
    const setToolSelected = useStickerSectionStore((state) => state.setToolSelected);
    const toolSelectedRef = useStickerSectionStore((state) => state.toolSelectedRef);

    const canUndo = useStickerSectionStore((state) => state.canUndo)

    const updateUndoRedoUI = () => {

        const dict = { canUndo: false, canRedo: false }

        if (UndoRedoHelper.undoStack.length > 1) {
            dict.canUndo = true
        }

        setUndoRedo(dict)

        if (selectedCanvasImageRef.current) {
            updateLayerStatus(selectedCanvasImageRef.current)
        }
    }

    const handleUndo = () => {
        selectedCanvasImageRef.current = null
        setCanvasImageSelected(false)
        UndoRedoHelper.undo()
        setToolSelected('selector')
        toolSelectedRef.current = "selector"

        for (const canvasImage of CanvasDrawer.canvasImages) {
            if (canvasImage.selected === true) {
                selectedCanvasImageRef.current = canvasImage
                setCanvasImageSelected(true)
            }
        }

        updateUndoRedoUI()

        CanvasDrawer.allocateGhostArrayImages()

        CanvasDrawer.rerenderCanvas()
    }

    const updateLayerStatus = (image: CanvasImage | null) => {
        let newAtBottom = false;
        let newAtTop = false;

        if (image && CanvasDrawer.canvasImages && CanvasDrawer.canvasImages.length > 0) {
            if (image.itemIndex === 0 && CanvasDrawer.canvasImages.length === 1) {
                newAtBottom = true;
                newAtTop = true;
            } else if (image.itemIndex === 0) {
                newAtBottom = true;
                newAtTop = false;
            } else if (image.itemIndex === CanvasDrawer.canvasImages.length - 1) {
                newAtBottom = false;
                newAtTop = true;
            } else {
                newAtBottom = false;
                newAtTop = false;
            }
        }
        setLayerStatusInStore({ isAtTop: newAtTop, isAtBottom: newAtBottom });
    };

    return (
        <div
            style={{
                width: "40%",
                height: "80%",
                border: "2px solid white",
                backgroundColor: "rgba(0, 0, 0, 0.7)",
                borderRadius: "10px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                transition: "background-color 0.3s ease, transform 0.1s ease, opacity 0.3s ease",
                cursor: "pointer",
                opacity: canUndo ? 1 : 0.7,
                WebkitTapHighlightColor: "transparent",
                touchAction: "manipulation",
                pointerEvents: "auto"

            }}

            onClick={handleUndo}


            onMouseDown={(e) => {
                e.currentTarget.style.transform = "scale(0.95)";
            }}
            onMouseUp={(e) => {
                e.currentTarget.style.transform = "scale(1)";
            }}
        >
            <FontAwesomeIcon icon={faUndo} color="white" />
        </div>
    )
}